// WHICH SERVICE this engagement is (NY F1 Round 5 · Owner ruling OD-9, 2026-09-09).
//
// Until Round 5 a property that was never previously occupied was BLOCKED (PP-20). The Owner's
// ruling replaces the block with a separate service: the same visual method, its own agreement and
// its own report, neither of which may call itself a home inspection (§444-b(6) puts a newly built
// structure outside the Article 12-B definition of "residential building").
//
//   homeInspection  the ordinary New York home inspection (Article 12-B · 19 NYCRR Part 197)
//   newBuild        New Build Visual Observation / 新建屋目视观察 (approved draft §4)
//
// It is DERIVED from the one fact the statute turns on — the inspector's own answer to "previously
// occupied as a dwelling?" — and is never a second, editable field that could disagree with it.
// UNKNOWN (null) is not a New Build: an unanswered question is handled by the workflow gate
// (src/domain/inspectionContext.ts), which does not let the formal workflow continue until it is
// answered once.
export type InspectionService = 'homeInspection' | 'newBuild';

export const INSPECTION_SERVICE_ORDER: readonly InspectionService[] = Object.freeze(['homeInspection', 'newBuild']);

export function isInspectionService(value: unknown): value is InspectionService {
  return value === 'homeInspection' || value === 'newBuild';
}

export function inspectionServiceOf(property: { previouslyOccupied: boolean | null }): InspectionService {
  return property.previouslyOccupied === false ? 'newBuild' : 'homeInspection';
}
